<ion-card>
  <ion-card-header>
    <ion-card-title>Közösségi szolgálat – KRÉTA-szinkron</ion-card-title>
    <ion-card-subtitle>
      A tanulók közösségi szolgálatának átvétele a KRÉTÁ-ból
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
    <div class="isz-hiba" *ngIf="hiba">{{ hiba }}</div>

    <ng-container *ngIf="!toltodik && !hiba">
      <p class="isz-lead">
        A KRÉTA a közösségi szolgálatot az <b>Adminisztrációs rendszer</b> szerepkörben vezeti. A szinkron
        belép egy már felvett KRÉTA-fiókkal, letölti a teljes listát, és frissíti az itteni
        nyilvántartást. <b>A KRÉTÁ-ban nem változtat semmit.</b> Az eredmény a
        <a routerLink="/iksz">Közösségi szolgálat</a> képernyőn látszik: az osztályfőnökök a saját
        osztályukat, az adminisztrátorok mindenkit.
      </p>

      <h3 class="isz-cim">Kapcsolat</h3>
      <div class="isz-racs">
        <ion-item>
          <ion-label position="stacked">KRÉTA-fiók a belépéshez</ion-label>
          <ion-select [(ngModel)]="b.forras_allomany" interface="popover" placeholder="– válassz fiókot –">
            <ion-select-option *ngFor="let f of fiokok" [value]="f.allomany">
              {{ f.tanar_nev || f.allomany }} ({{ f.kreta_user }})
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox [(ngModel)]="b.automatikus" labelPlacement="end">
            Éjszakánként magától (hajnali 2 és 5 óra között)
          </ion-checkbox>
        </ion-item>
      </div>
      <ion-note color="medium" class="isz-megj" *ngIf="!fiokok.length">
        Még nincs felvett KRÉTA-fiók. A fiókokat az <b>E-napló → KRÉTA naplózás</b> menüben lehet
        felvenni; a szinkronhoz olyan fiók kell, amelynek van <b>Adminisztrációs rendszer</b> szerepköre.
      </ion-note>
      <ion-note color="medium" class="isz-megj" *ngIf="fiokok.length">
        A kiválasztott fióknak a KRÉTÁ-ban <b>Adminisztrációs rendszer</b> szerepkörrel kell rendelkeznie.
        A jelszót nem másoljuk át: mindig a KRÉTA naplózásnál megadott belépést használjuk.
      </ion-note>

      <div class="isz-gombok">
        <ion-button size="small" fill="outline" (click)="mentes()" [disabled]="ment">Beállítás mentése</ion-button>
        <ion-button size="small" (click)="szinkron()" [disabled]="folyamat?.fut || !b.forras_allomany">
          <ion-icon slot="start" name="sync-outline"></ion-icon>
          Szinkron indítása most
        </ion-button>
      </div>

      <div class="isz-allapot" *ngIf="folyamat?.fut">
        <ion-spinner name="dots"></ion-spinner>
        <span>Fut: <b>{{ folyamat.lepes }}</b></span>
      </div>
      <div class="isz-allapot jo" *ngIf="folyamat && !folyamat.fut && folyamat.eredmeny">
        Kész: {{ folyamat.eredmeny.kreta_db }} KRÉTA-tétel – {{ folyamat.eredmeny.uj }} új,
        {{ folyamat.eredmeny.frissitett }} frissült, {{ folyamat.eredmeny.torolt }} törölve.
        <span *ngIf="folyamat.eredmeny.helyi_elsobbseg">
          {{ folyamat.eredmeny.helyi_elsobbseg }} itt módosított tételt nem írt felül.
        </span>
        <span *ngIf="folyamat.eredmeny.parositatlan">
          {{ folyamat.eredmeny.parositatlan }} tétel tanulóját nem találtuk.
        </span>
      </div>
      <div class="isz-allapot baj" *ngIf="folyamat && !folyamat.fut && folyamat.hiba">
        A szinkron nem sikerült: {{ folyamat.hiba }}
      </div>

      <ng-container *ngIf="osszesito">
        <h3 class="isz-cim">Nyilvántartás</h3>
        <div class="isz-szamok">
          <div><span class="szam">{{ osszesito.tetel }}</span><span>tétel</span></div>
          <div><span class="szam">{{ osszesito.kretabol }}</span><span>a KRÉTÁ-ból</span></div>
          <div><span class="szam">{{ osszesito.sulinformbol }}</span><span>itt rögzítve</span></div>
          <div [class.var]="osszesito.visszairasra_var > 0">
            <span class="szam">{{ osszesito.visszairasra_var }}</span><span>KRÉTÁ-ba visszaírandó</span>
          </div>
          <div [class.baj]="osszesito.parositatlan > 0">
            <span class="szam">{{ osszesito.parositatlan }}</span><span>tanuló nélkül</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="visszairando.length">
        <h3 class="isz-cim">KRÉTÁ-ba visszaírandó tételek</h3>
        <ion-note color="medium" class="isz-megj">
          Ezeket itt rögzítették, módosították vagy törölték. <b>Az automatikus visszaírás még nincs
          bekapcsolva</b>: amíg nem az, a KRÉTÁ-ban kézzel kell átvezetni őket. A következő szinkron
          addig sem írja felül az itteni változatot.
        </ion-note>
        <div class="isz-tabla-burok">
          <table class="isz-tabla">
            <thead>
              <tr><th>Tanuló</th><th>Kezdete</th><th class="szam">Óra</th><th>Tevékenység</th><th>Változás</th><th>Ki</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of visszairando">
                <td>{{ v.nev || v.oktazon }}</td>
                <td class="datum">{{ v.kezdete }}</td>
                <td class="szam">{{ v.oraszam }}</td>
                <td class="tipus" [title]="v.tipus">{{ v.tipus }}</td>
                <td>{{ v.torolve ? 'törölve' : (v.kreta_id ? 'módosítva' : 'új tétel') }}</td>
                <td>{{ v.ki || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-container *ngIf="parositatlan.length">
        <h3 class="isz-cim">Tanuló nélküli KRÉTA-tételek</h3>
        <ion-note color="medium" class="isz-megj">
          Ezeknek a tanulóját nem találtuk meg a nyilvántartásban (az oktatási azonosító alapján). Ha a
          tanulót később felvesszük, a következő szinkron hozzárendeli.
        </ion-note>
        <div class="isz-tabla-burok">
          <table class="isz-tabla">
            <thead><tr><th>Tanuló (KRÉTA)</th><th>Osztály</th><th>Kezdete</th><th class="szam">Óra</th><th>Tevékenység</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of parositatlan">
                <td>{{ p.nev }}</td><td>{{ p.osztaly }}</td><td class="datum">{{ p.kezdete }}</td>
                <td class="szam">{{ p.oraszam }}</td><td class="tipus" [title]="p.tipus">{{ p.tipus }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-container *ngIf="futasok.length">
        <h3 class="isz-cim">Korábbi szinkronok</h3>
        <div class="isz-tabla-burok">
          <table class="isz-tabla">
            <thead>
              <tr><th>Indult</th><th>Állapot</th><th>Indította</th><th class="szam">KRÉTA</th><th class="szam">Új</th><th class="szam">Frissült</th><th class="szam">Törölve</th><th class="szam">Tanuló nélkül</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of futasok">
                <td class="datum">{{ f.indult }}</td>
                <td>
                  <span class="jel jo" *ngIf="f.allapot === 'kesz'">kész</span>
                  <span class="jel" *ngIf="f.allapot === 'fut'">fut</span>
                  <span class="jel baj" *ngIf="f.allapot === 'hiba'" [title]="f.hiba || ''">hiba</span>
                </td>
                <td>{{ f.inditotta || '—' }}</td>
                <td class="szam">{{ f.kreta_db ?? '—' }}</td>
                <td class="szam">{{ f.uj ?? '—' }}</td>
                <td class="szam">{{ f.frissitett ?? '—' }}</td>
                <td class="szam">{{ f.torolt ?? '—' }}</td>
                <td class="szam">{{ f.parositatlan_db ?? '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
